<script>

    import { toast } from 'bulma-toast'
    import { pricingStore, pricingsStore, modalStore } from '../stores'

    import PricingsService from '../$services/pricings.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'

    let loading = false

    async function deletePricing() {

        loading = true
        const resp = await PricingsService.deletePricing($pricingStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricingsStore.remove($pricingStore._id)
        toast({message: 'Pricing borrado', type: 'is-success'})
        
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title={'Precio'}
        meta={`Actualizado · ${DateMethod.dateTimeLarge($pricingStore.updated)}`}
        statusValue={$pricingStore.status}
    >
        <DetailsFields>
            {#if $pricingStore.admin}
                <DetailsField label="Admin" value={$pricingStore.admin.name} />
            {/if}
            <DetailsField label="Proveedor" value={$pricingStore.provider} />
            <DetailsField label="Servicio" value={$pricingStore.service} />
            <DetailsField label="Volumétrico mín." value={`${$pricingStore.volumetricMin} kg`} />
            <DetailsField label="Volumétrico máx." value={`${$pricingStore.volumetricMax} kg`} />
            <DetailsField label="Costo de envío" value={`$${$pricingStore.shipmentCost}`} mono />
            <DetailsField label="Precio de envío" value={`$${$pricingStore.shipmentPrice}`} mono />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button on:click={() => modalStore.open('pricing', 'update_modal', $pricingStore)} icon="edit" text="Actualizar" { loading } />
                    <ButtonDelete on:confirm={deletePricing} { loading } />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
